module.exports = __webpack_public_path__ + "img/myluxura-module.sticker.8b7f1c39.svg";